import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material';

import { RoyaltyReportRoutingModule } from './royalty-report-routing.module';
import { SharedModule } from '../shared/shared.module';
import { RoyaltyReportComponent } from './royalty-report.component';
// import { SitesFilterComponent } from '../sites/sites-filter/sites-filter.component';
// import { SiteHealthComponent } from './site-health/site-health.component';
// import { SiteOnboardingComponent } from './site-onboarding/site-onboarding.component';
// import { SiteCentersComponent } from './site-centers/site-centers.component';
// import { SiteEditComponent } from './site-edit/site-edit.component';
// import { SiteEditModalComponent } from './site-edit-modal/site-edit-modal.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    RoyaltyReportRoutingModule,
    MatDialogModule,
  ],
  // entryComponents: [SiteEditModalComponent],
  declarations: [
    RoyaltyReportComponent,
    // SitesFilterComponent,
    // SiteHealthComponent,
    // SiteOnboardingComponent,
    // SiteCentersComponent,
    // SiteEditComponent,
    // SiteEditModalComponent
  ],
})
export class RoyaltyReportModule { }
